import React, { useEffect } from 'react';
import { usePageElement } from '@99designs/tracking';
import { useOnboarder } from './OnboarderContext';
import { useOnboarderNav } from './useOnboarderNav';

export interface WithPageWrapperProps {
    onPageChange: (title: string, description: string) => void;
}

export function withPageWrapper<T extends WithPageWrapperProps>(
    WrappedComponent: React.ComponentType<T>
) {
    const displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    const ComponentWithPageWrapper = (props: T) => {
        const {
            config: { pageTitle },
        } = useOnboarder();
        const onboarderNav = useOnboarderNav();
        const currentStep = onboarderNav.currentStep();
        usePageElement();

        const { onPageChange, ...wrappedComponentProps } = props;

        useEffect(() => {
            currentStep
                ? onPageChange(`${pageTitle} - ${currentStep.title}`, '')
                : onPageChange(pageTitle, '');
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [currentStep]);

        return <WrappedComponent {...(wrappedComponentProps as T)} />;
    };

    ComponentWithPageWrapper.displayName = `withPageWrapper(${displayName})`;

    return ComponentWithPageWrapper;
}
